import React from "react";
import SummaryStationWise from "../SummaryStationWise";
import SummaryStationWiseForAvr from "../SummaryStationWiseForAvr";

export default function StationWiseSummary({ sessionObject }) {
  if (
    !sessionObject.sessionVariables["modules"].includes("station-wise-summary")
  ) {
    return null;
  }

  if (["avr", "sgtc", "std", "bgtc", "arbuda", "jtsa"].includes(process.env.REACT_APP_CLIENT)) {
    return (
      <div className="page-challan">
        <SummaryStationWiseForAvr sessionObject={sessionObject} />
      </div>
    );
  }

  return (
    <div className="page-challan">
      <SummaryStationWise sessionObject={sessionObject} />
    </div>
  );
}
